import { render, staticRenderFns } from "./tcgnavbar.vue?vue&type=template&id=349933c3&scoped=true&"
import script from "./tcgnavbar.vue?vue&type=script&lang=ts&"
export * from "./tcgnavbar.vue?vue&type=script&lang=ts&"
import style0 from "./tcgnavbar.vue?vue&type=style&index=0&id=349933c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349933c3",
  null
  
)

export default component.exports